import { addSource } from './addCognosSource.api';
import { getCsvUrl } from './getCsvUrl.api';

export async function createDashboard(api, reportId, reportName, callback) {
	if (api.dashboard !== null) {
		const dashboardApi = await api.dashboard.createNew();

		await callback(dashboardApi);

		console.log('createDashboard...');

		await getCsvUrl(reportId).then((url) => {
			console.log('Starting getCsvUrl...');
			console.log('This is the url', url);

			if (!url) {
				console.log('Did not get getCsvUrl...trying again...');
				getCsvUrl(reportId).then((url) => {
					dashboardApi.on(
						'addSource:clicked',
						sourceClicked(dashboardApi, url, reportName)
					);
				});
			} else {
				dashboardApi.on(
					'addSource:clicked',
					sourceClicked(dashboardApi, url, reportName)
				);
			}

			return dashboardApi;
		});
	} else {
		console.log('Dashboard not created');
	}
}

function sourceClicked(dashboardApi, url, reportId) {
	console.log('dashboardApijjj', dashboardApi, url);
	addSource(dashboardApi, url, reportId);
}
